import { Component, Input, SimpleChanges } from "@angular/core";
import { IFilterOptions } from "@app/interfaces/filters/IFilterOptions";
import { IDriver } from "@app/interfaces/IDriver";
import { IDashboardWidget } from "@app/main/modules/dashboard/_models/IDashboardWidget";
import { DateService } from "@app/services/date.service";
import { DriverService } from "@app/services/driver.service";
import { GroupService } from "@app/services/groups/group.service";
import { DriverInfringementStatus, IDriverTachoHours, TachoService } from "@app/services/tacho.service";
import { IDriverTachoWarning } from "../../_models/IDriverTachoWarning";
import './tacho-warnings-widget.component.scss';

@Component({
    selector: 'v-tacho-warnings-widget',
    template: require('./tacho-warnings-widget.component.html')
})
export class VTachoWarningsWidgetComponent {
    @Input() widget: IDashboardWidget;
    @Input() filterOptions: IFilterOptions;

    popupEvent: MouseEvent;

    warnings: IDriverTachoWarning[] = [];
    highlightedWarning: IDriverTachoWarning;

    interval: ReturnType<typeof setInterval>;

    loading = false;

    constructor(
        private readonly dateService: DateService,
        private readonly driverService: DriverService,
        private readonly groupService: GroupService,
        private readonly tachoService: TachoService) {
    }

    ngOnInit(): void {
        this.loadData(true);

        this.interval = setInterval(() => {
            this.loadData();
        }, 60_000);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['filterOptions']) {
            this.loadData();
        }
    }

    showHidePopup(warning: IDriverTachoWarning, $event: MouseEvent) {
        this.popupEvent = warning ? $event : null;
        this.highlightedWarning = warning;
    }

    // ---

    private loadData(showLoadingIndicator = false) {
        this.loading = showLoadingIndicator;

        const driverPromise = this.driverService.getDrivers() as Promise<IDriver[]>;
        const tachoPromise = this.tachoService.getCurrentTachoForAllDrivers(false) as Promise<IDriverTachoHours[]>;

        Promise
            .all([driverPromise, tachoPromise])
            .then(([drivers, tachoStates]) => {

                this.warnings = [];

                tachoStates.forEach(tachoState => {
                    if (tachoState.TimeRelatedStates == 0) {
                        return;
                    }

                    if (this.filterOptions && this.filterOptions.groupFilter && this.filterOptions.groupFilter.group && !this.groupService.hasDriver(this.filterOptions.groupFilter.group, tachoState.DriverId)) {
                        return;
                    }

                    var message = this.tachoService.getStatusMessage(tachoState.TimeRelatedStates);
                    var tachoWarning: IDriverTachoWarning = {
                        driver: this.driverService.findDriver(drivers, tachoState.DriverId),
                        message: message[0],
                        status: message[1],
                        statusMessage: DriverInfringementStatus[message[1]],
                        tachoState: tachoState,
                        time: this.dateService.formatDuration(tachoState.EventTime, new Date(), { style: "narrow" })
                    };

                    this.warnings.push(tachoWarning);
                });

                this.warnings.sort((w1, w2) => {
                    if (w1.status > w2.status) { return -1; }
                    if (w1.status < w2.status) { return 1; }
                });

            }).finally(() => {
                this.loading = false;
            });
    }
}
